import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import AchievementService from "../../../../Services/Achievement.service";
import useUniqueId from "../../../Hooks/useUniqueId";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import DeprecatedSelect from "../../../UI/DeprecatedSelect/DeprecatedSelect";
export const getItemEventSearchPieceFromAchievementFilterState = (state) => {
    if (!state.achievements) {
        return null;
    }
    return {
        activityItemTypeIds: [ActivityItemTypeService.PersonAchievementId],
        types: state.achievements.map((achievement) => achievement.id),
    };
};
const AchievementFilter = (props) => {
    const makeId = useUniqueId()[1];
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("achievement"), className: "sr-only", children: "Achievement Types" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { multi: true, id: makeId("achievement"), placeholder: "Achievement Types", loadOptions: (search) => 
                        // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type 'number | undefined'.
                        AchievementService.search(search, null, null, true).then(({ data }) => ({
                            options: data,
                        })), value: props.state.achievements, valueKey: "id", labelKey: "name", onChange: (achievements) => props.setState({ achievements }) }) })] }) }));
};
export default AchievementFilter;
